module.exports = __webpack_public_path__ + "static/media/add-red-icon.654f1293.svg";